<template>
 
  <gh-table-page v-model="selectedModels" ref="table" :show-tabs="true" :tabs="tabs" :args-query="argsQuery"
    :module="module" :cls="cls" :template-model="itemTemplate" @save-after="$refs.struNav.query()"
    @delete-after="$refs.struNav.query()">
    <template #area_left>
      <structure-navigation ref="struNav" v-model="selectedStructure" @update:dataSource="invokeStatisticCount">
        <template #node-append="{node,data}">
          -<strong class="text--primary font-italic">{{getCount(data.Id)}}</strong>&nbsp<span> </span>
        </template>
      </structure-navigation>
    </template>

    <template #area_query>
      <slot name="area_query">
        <v-layout row align-center>

          <v-text-field v-model="argsQuery.keywords" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline"></v-text-field>
        </v-layout>
      </slot>

    </template>
    <template #area_operation_before>
      <structure-selector v-if="selectedModels.length>0" btnText="调配" title="请选择结构" :after-submit="changeStructureTo">
      </structure-selector>
    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import DependedStructure from "./dependedStructure.ts";
  export default DependedStructure;
</script>